module.exports = __webpack_public_path__ + "static/media/specials.ce446ba3.jpg";